module.exports = __webpack_public_path__ + "static/media/undraw_feeling_proud_qne1.bef111f7.svg";